import SaveButton from "../../../../components/SaveButton";
import TextInput from "../../../../components/TextInput";
import { useEffect, useState } from "react";
import CancelButton from "../../../../components/CancelButton";
import { useRecoilState, useRecoilValue } from "recoil";
import { workFromHome } from "../atoms/atoms";
import { toast } from "../../../../components/toastNotification";
import { accountAtom } from "modules/Login/atoms/AccountAtom";

export const MassUploadExpandedRow = ({
  data,
  isEdit = false,
  updateRow,
  setShowEdit,
  setShow,
  setDisplayNote,
  handleActions,
}) => {
  const user = useRecoilValue(accountAtom);
  const [formData, setFormData] = useState(data);
  const [validWorkFrom, setValidWorkFromHome] = useRecoilState(workFromHome);
  const [timezone] = useState("");
  const officeName = formData.officeName
    ?.toLocaleLowerCase()
    ?.includes("work from home");

  function getOfficeTimeZone(url_Request) {
    var xhr = new XMLHttpRequest(); // create new XMLHttpRequest2 object
    return new Promise((resolve, reject) => {
      xhr.open("GET", url_Request); // open GET request
      xhr.onload = function () {
        if (xhr.status === 200) {
          // if Ajax request successful
          var output = JSON.parse(xhr.responseText);
          if (output.status === "OK") {
            resolve(output);
          }
        }
      };
      xhr.send();
    });
  }

  function getOfficeLocation(url_Request) {
    var xhr = new XMLHttpRequest(); // create new XMLHttpRequest2 object
    return new Promise((resolve, reject) => {
      xhr.open("GET", url_Request); // open GET request
      xhr.onload = function () {
        if (xhr.status === 200) {
          // if Ajax request successful
          var output = JSON.parse(xhr.responseText);
          if (output.status === "OK") {
            resolve(output);
          }
        }
      };
      xhr.send();
    });
  }

  useEffect(() => {
    if ((validWorkFrom && isEdit) || (officeName && isEdit)) {
      formData.address = "7711 Center Ave St 200";
    }
    if (validWorkFrom || officeName) {
      if (
        formData?.city !== "" &&
        formData?.zipCode !== "" &&
        formData?.state !== ""
      ) {
        var URLGeo =
          "https://maps.googleapis.com/maps/api/geocode/json?address=" +
          formData?.city +
          "," +
          formData?.zipCode +
          "," +
          formData?.state +
          "&key=" +
          user?.googleTimezoneApiKey;
        getOfficeLocation(URLGeo).then((res) => {
          const { results: result } = res;
          const locLattitude = result && result[0]?.geometry?.location?.lat;
          const locLongitude = result && result[0]?.geometry?.location?.lng;

          //TimeZone
          const targetDate = new Date();

          var timestamp =
            targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60; //Converts datetime in current timezone to seconds
          const geoLocation = locLattitude + "," + locLongitude;
          const url_Request =
            "https://maps.googleapis.com/maps/api/timezone/json?location=" +
            geoLocation +
            "&timestamp=" +
            timestamp +
            "&key=" +
            user?.googleTimezoneApiKey;
          let officeTimeZone = "";
          let officeDaylight = "";
          getOfficeTimeZone(url_Request).then((res) => {
            const shippingDaylightSavings = res.dstOffset > 0 ? true : false;

            officeTimeZone = timezone;
            officeDaylight = shippingDaylightSavings;
          });
        });
      }
    }
  }, [
    formData.officeName,
    formData.city,
    formData.state,
    formData.zipcode,
    officeName,
    validWorkFrom,
  ]);

  const handleChange = (event) => {
    setValidWorkFromHome(false);
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = () => {
    if (
      formData.officeName &&
      formData.officeStatusDetail &&
      formData.address &&
      formData.zipCode &&
      formData.officeType &&
      formData.brandName &&
      formData.city &&
      formData.country &&
      formData.officeStatus &&
      formData.licenseNumber &&
      formData.state
    ) {
      updateRow({
        ...formData,
        expandRow: false,
        dateOpen:
          formData.dateOpen === null
            ? null
            : isNaN(new Date(formData.dateOpen))
            ? null
            : new Date(formData.dateOpen).toISOString().split("T")[0],

        dateClosed:
          formData.dateClosed === null
            ? null
            : isNaN(new Date(formData.dateClosed))
            ? null
            : new Date(formData.dateClosed).toISOString().split("T")[0],
      });

      setShowEdit(false);
      setShow(false);
      setDisplayNote(true);
    } else {
      toast.fire(
        "Saving Failed",
        "All required fields must be filled!",
        "error"
      );
    }
  };

  return (
    <div className="w-full">
      <div className="p-4 space-y-4 border-l-2 border-quinary rounded-bl-none rounder-r-none box-shadow mb-2">
        {isEdit && (
          <div>
            {" "}
            <div className=" flex justify-between">
              <div className="flex item-center">
                <div className="font-bold text-sm text-primary ">
                  Edit Office Mass Upload
                </div>
              </div>

              <div className="flex gap-2">
                <SaveButton onClick={handleSubmit} />
                <CancelButton onClick={() => handleActions(data, "Hide")} />
              </div>
            </div>
            {officeName && (
              <>
                <div className="text-xs">
                  <span className="italic grid-cols-3 object-left-bottom text-red-500">
                    <b>Note:</b> Address has been changed due to WFH Office Name
                  </span>
                </div>
              </>
            )}
          </div>
        )}
        <div className="text-xs font-medium  ">
          <div className="grid grid-flow-col grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2 ">
                  Office Name: <span className="text-red-500">*</span>
                </div>
              ) : (
                <div className="font-normal text-right mr-2">Office Name:</div>
              )}
              {isEdit ? (
                <TextInput
                  type="text"
                  name="officeName"
                  value={formData.officeName}
                  className="font-normal"
                  required={true}
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium"> {formData.officeName}</div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Office Type: <span className="text-red-500">*</span>
                  </div>
                  <TextInput
                    type="text"
                    value={formData.officeType}
                    className="font-normal"
                    name="officeType"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </>
              ) : (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Office Type:
                  </div>
                  <div className="font-medium">{formData.officeType}</div>
                </>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Office Status: <span className="text-red-500">*</span>
                  </div>
                  <TextInput
                    type="text"
                    value={formData.officeStatus}
                    className="font-normal"
                    name="officeStatus"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </>
              ) : (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Office Status:
                  </div>
                  <div className="font-medium">{formData.officeStatus}</div>
                </>
              )}
            </div>
          </div>
          <div className="grid grid-flow-col grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Office Status Details:{" "}
                    <span className="text-red-500">*</span>
                  </div>
                  <TextInput
                    type="text"
                    value={formData.officeStatusDetail}
                    className="font-normal"
                    name="officeStatusDetail"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </>
              ) : (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Office Status Details:
                  </div>
                  <div className="font-medium">
                    {formData.officeStatusDetail}
                  </div>
                </>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2">
                  Brand Name: <span className="text-red-500">*</span>
                </div>
              ) : (
                <div className="font-normal text-right mr-2">Brand Name:</div>
              )}
              {isEdit ? (
                <TextInput
                  value={formData.brandName || formData.BrandId}
                  className="font-normal"
                  name="brandName"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium">{formData.brandName}</div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Legal Entity License:{" "}
                    <span className="text-red-500">*</span>
                  </div>
                  <TextInput
                    type="text"
                    value={formData.licenseNumber}
                    className="font-normal"
                    name="licenseNumber"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </>
              ) : (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Legal Entity License:
                  </div>
                  <div className="font-medium">{formData.licenseNumber}</div>
                </>
              )}
            </div>
          </div>
          <div className="grid grid-flow-col grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <>
                  <div className="font-normal text-right mr-2 ">
                    Phone: <span className="text-red-500">*</span>
                  </div>
                  <TextInput
                    type="text"
                    value={formData.phoneNumber}
                    className="font-normal"
                    name="phoneNumber"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </>
              ) : (
                <>
                  <div className="font-normal text-right mr-2 ">Phone:</div>
                  <div className="font-medium">{formData.phoneNumber}</div>
                </>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2 ">
                  Address: <span className="text-red-500">*</span>
                </div>
              ) : (
                <div className="font-normal text-right mr-2">Address:</div>
              )}
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.address}
                  className="font-normal"
                  name="address"
                  onChange={(e) => handleChange(e)}
                  required={true}
                />
              ) : (
                <div className="font-medium">{formData.address}</div>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2 ">
                  City: <span className="text-red-500">*</span>
                </div>
              ) : (
                <div className="font-normal text-right mr-2">City:</div>
              )}
              {isEdit ? (
                <TextInput
                  value={formData.city}
                  className="font-normal"
                  name="city"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-nmedium">{formData.city}</div>
              )}
            </div>
          </div>
          <div className="grid grid-flow-col grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2">
                  State: <span className="text-red-500">*</span>
                </div>
              ) : (
                <div className="font-normal text-right mr-2">State:</div>
              )}
              {isEdit ? (
                <TextInput
                  type="text"
                  name="state"
                  value={formData.state}
                  className="font-normal"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium"> {formData.state}</div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2 ">
                  Zip Code: <span className="text-red-500">*</span>
                </div>
              ) : (
                <div className="font-normal text-right mr-2">Zip Code:</div>
              )}
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.zipCode}
                  className="font-normal"
                  name="zipCode"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium">{formData.zipCode}</div>
              )}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2 ">
                  Country: <span className="text-red-500">*</span>
                </div>
              ) : (
                <div className="font-normal text-right mr-2">Country:</div>
              )}
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.country}
                  className="font-normal"
                  name="country"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-nmedium">{formData.country}</div>
              )}
            </div>
          </div>
          <div className="grid grid-flow-col grid-cols-3  gap-5 m-3">
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2">
                  Office Department:
                </div>
              ) : (
                <div className="font-normal text-right mr-2">
                  Office Department:
                </div>
              )}
              {isEdit ? (
                <TextInput
                  type="text"
                  name="officeDepartmentName"
                  value={formData.officeDepartmentName}
                  className="font-normal"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium">
                  {" "}
                  {formData.officeDepartmentName}
                </div>
              )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2  w-full items-center gap-2">
              {isEdit ? (
                <div className="font-normal text-right mr-2">
                  Account Owner /
                  <br />
                  Created By:
                </div>
              ) : (
                <div className="font-normal text-right mr-2">
                  Account Owner /
                  <br />
                  Created By:
                </div>
              )}
              {isEdit ? (
                <TextInput
                  type="text"
                  value={formData.createdBy}
                  className="font-normal"
                  name="createdBy"
                  onChange={(e) => handleChange(e)}
                />
              ) : (
                <div className="font-medium"> {formData.createdBy}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
